import { configureStore } from "@reduxjs/toolkit";
import partieReducer from "./partieSlice";

const loadState = () => {
  try {
    const serializedState = localStorage.getItem("GameSet");
    return serializedState ? JSON.parse(serializedState) : undefined;
  } catch (e) {
    console.warn("Erreur chargement localStorage", e);
    return undefined;
  }
};

// Fonction pour sauvegarder l'état dans localStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state.partie);
    localStorage.setItem("GameSet", serializedState);
  } catch (e) {
    console.warn("Erreur sauvegarde localStorage", e);
  }
};

const store = configureStore({
  reducer: {
    partie: partieReducer,
  },
  preloadedState: { partie: loadState() ?? [] },
});

// Sauvegarde à chaque changement
store.subscribe(() => {
  saveState(store.getState());
});

export default store;
